import * as yup from 'yup'
import { isEmpty } from 'lodash'

import constants from 'constants/index'

const { JUSTIFY_MAX_LENGTH } = constants.privacyByDesign

// Schema de uma única questão: justificativa e evidência são obrigatórias apenas
// quando a alternativa marcada exige, então as flags das alternativas do projeto
// definem as regras.
const schema = (question = {}) => {
  const alternatives = question.questionAlternatives || []

  const idsRequiring = (flag) =>
    alternatives
      .filter((alternative) => alternative[flag])
      .map((alternative) => alternative.id)

  const alternativeIdsRequiringJustify = idsRequiring('observationsRequired')
  const alternativeIdsRequiringEvidence = idsRequiring('evidencesRequired')

  return yup.object({
    justify: yup.string().when('questionAlternativeId', {
      is: (questionAlternativeId) =>
        alternativeIdsRequiringJustify.includes(Number(questionAlternativeId)),
      then: yup
        .string()
        .trim()
        .max(JUSTIFY_MAX_LENGTH)
        .required(
          'A alternativa selecionada exige o preenchimento da justificativa',
        ),
      otherwise: yup.string().max(JUSTIFY_MAX_LENGTH).nullable(),
    }),
    evidences: yup.mixed().when('questionAlternativeId', {
      is: (questionAlternativeId) =>
        alternativeIdsRequiringEvidence.includes(Number(questionAlternativeId)),
      then: yup
        .mixed()
        .test(
          'evidence-required',
          'A alternativa selecionada exige o anexo de uma evidência',
          (value) => !isEmpty(value),
        ),
      otherwise: yup.mixed().nullable(),
    }),
  })
}

export default schema
